import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Label, Input, Table } from "reactstrap";
import axios from "axios";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Header from "../../../layout/Header/Header";

function ReportePendientesVendedor() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;

  const hoy = moment().format("YYYY-MM-DD");
  const hace30 = moment().subtract(30, "days").format("YYYY-MM-DD");

  const [fechaInicio, setFechaInicio] = useState(hace30);
  const [fechaFin, setFechaFin] = useState(hoy);
  const [rows, setRows] = useState([]);
  const [tipo, setTipo] = useState(""); // "" todo, "fiscal", "no-fiscal"

  const cargar = async () => {
    try {
      const res = await axios.get(`${URL_SURTIDOS}Fechas/${fechaInicio}/${fechaFin}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const arr = (res.data || [])
        .filter((s) => s.is_active === "Si" && Number(s.saldo || 0) > 0)
        .map((s) => {
          const ped = s.pedidos?.[0] || {};
          const cli = s.clientes?.[0] || ped.clientes?.[0] || {};
          const colab = ped.colaboradores?.[0] || {};
          const plazo = Number(cli.plazo || 0);
          const fechaSur = s.fecha || "";
          const vencimiento = fechaSur ? moment(fechaSur).add(plazo, "days").format("YYYY-MM-DD") : "";
          const diasVencido = vencimiento ? moment().diff(moment(vencimiento), "days") : 0;
          return {
            _id: s._id,
            numero: s.idSurtido,
            fecha: fechaSur,
            cliente: cli.nombre_comercial || "",
            vendedor: (colab.nombre || "") + " " + (colab.apellido || ""),
            idVendedor: colab._id || "",
            plazo,
            vencimiento,
            diasVencido,
            saldo: Number(s.saldo || 0),
            total: Number(s.total_general || 0),
            requiereFactura: s.requiereFactura || "Pendiente",
            facturado: s.facturado || "No",
            esFiscal: s.facturado === "Si",
          };
        });
      setRows(arr);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fechaInicio, fechaFin]);

  const rowsFiltradas = rows.filter((r) => {
    if (tipo === "fiscal") return r.esFiscal;
    if (tipo === "no-fiscal") return !r.esFiscal;
    return true;
  });

  // Agrupar por vendedor
  const agrup = rowsFiltradas.reduce((acc, r) => {
    const k = r.idVendedor || r.vendedor || "(sin vendedor)";
    if (!acc[k]) acc[k] = { vendedor: r.vendedor || "(sin vendedor)", notas: [], saldoTotal: 0, vencido: 0 };
    acc[k].notas.push(r);
    acc[k].saldoTotal += r.saldo;
    if (r.diasVencido > 0) acc[k].vencido += r.saldo;
    return acc;
  }, {});
  const lista = Object.values(agrup);

  function pdf() {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Pendientes de Pago por Vendedor", 14, 18);
    doc.setFontSize(10);
    doc.text(`Periodo: ${fechaInicio} - ${fechaFin} · Tipo: ${tipo || "Todos"}`, 14, 26);
    let y = 34;
    lista.forEach((g) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${g.vendedor} — Saldo: $${g.saldoTotal.toFixed(2)} (Vencido $${g.vencido.toFixed(2)})`, 14, y);
      y += 4;
      const body = g.notas.map((n) => [
        n.numero, n.fecha, n.cliente, n.vencimiento, n.diasVencido,
        `$${n.saldo.toFixed(2)}`, n.esFiscal ? "Fiscal" : "No fiscal",
      ]);
      doc.autoTable({
        head: [["Venta", "Fecha", "Cliente", "Vence", "Días", "Saldo", "Tipo"]],
        body, startY: y, theme: "grid", styles: { fontSize: 8 },
        headStyles: { fillColor: [176, 35, 7] },
      });
      y = doc.autoTable.previous.finalY + 6;
      if (y > 270) { doc.addPage(); y = 20; }
    });
    abrePDF(doc, "Pendientes-x-Vendedor.pdf");
  }

  return (
    <>
      <Header />
      <div className="container">
        <h3 align="center">Pendientes de Pago por Vendedor</h3>
        <Row>
          <Col md={2}>
            <Label>Fecha Inicio</Label>
            <Input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
          </Col>
          <Col md={2}>
            <Label>Fecha Fin</Label>
            <Input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
          </Col>
          <Col md={2}>
            <Label>Tipo</Label>
            <Input type="select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="">Todos</option>
              <option value="fiscal">Fiscal (facturado)</option>
              <option value="no-fiscal">No fiscal</option>
            </Input>
          </Col>
          <Col md={2} style={{ display: "flex", alignItems: "flex-end" }}>
            <Button color="danger" onClick={pdf}>
              PDF <i className="far fa-file-pdf"></i>
            </Button>
          </Col>
        </Row>
        <br />
        {lista.map((g) => (
          <div key={g.vendedor} style={{ marginBottom: 16 }}>
            <h5>
              {g.vendedor} — Saldo: ${g.saldoTotal.toFixed(2)}{" "}
              {g.vencido > 0 && (
                <span style={{ color: "#dc3545" }}>(Vencido ${g.vencido.toFixed(2)})</span>
              )}
            </h5>
            <Table size="sm" striped bordered>
              <thead>
                <tr>
                  <th>Nota</th><th>Fecha</th><th>Cliente</th><th>Vence</th><th>Días</th><th>Saldo</th><th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                {g.notas.map((n) => (
                  <tr key={n._id} style={n.diasVencido > 0 ? { backgroundColor: "#fff2b2" } : {}}>
                    <td>{n.numero}</td>
                    <td>{n.fecha}</td>
                    <td>{n.cliente}</td>
                    <td>{n.vencimiento}</td>
                    <td>{n.diasVencido > 0 ? <b style={{ color: "#dc3545" }}>{n.diasVencido}</b> : "—"}</td>
                    <td>${n.saldo.toFixed(2)}</td>
                    <td>{n.esFiscal ? "Fiscal" : "No fiscal"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ))}
      </div>
    </>
  );
}

export default ReportePendientesVendedor;
